module.exports = __webpack_public_path__ + "img/jk_city.ddad8370.jpg";